module.exports = __webpack_public_path__ + "media/images/like_this_cmnd_front-f52b5b9723facc5896ef9a5ae3fac894.jpg";